// extracted by mini-css-extract-plugin
export default {"overlay":"gI-z","bodyOpen":"hI-z","content":"iI-z","header":"jI-z","close":"kI-z","closeNoHeading":"lI-z"};